import React, {PureComponent} from 'react';
import TranslatedText from './TranslatedText';
import swipeIcon from '../assets/icon-swipe.svg';

import './Rotation.css';

export default class Rotation extends PureComponent {
    imageRef = React.createRef();

    updateImage(image) {
        this.imageRef.current.src = image;
    }

    render() {
        return (
            <div className="Rotation">
                <img
                    className="Rotation-img"
                    ref={this.imageRef}
                    src={this.props.img}
                    alt=""
                    draggable="false"
                />
                <div className="Rotation-icon">
                    <img src={swipeIcon} alt="" draggable="false" />
                    <TranslatedText tag={this.props.label} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/atoms/Rotation.js